import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicyPage: React.FC = () => {
  const lastUpdated = "January 1, 2024";
  const companyName = "SaaS Starter Inc.";
  const dpoEmail = "privacy@example.com";

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 max-w-3xl">
      <header className="mb-10 text-center">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-foreground mb-3">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground">Last Updated: {lastUpdated}</p>
      </header>

      <section className="space-y-6 text-foreground/90 leading-relaxed">
        <p>
          Welcome to {companyName} ("we," "us," or "our"). We are committed to protecting your privacy.
          This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
        </p>
        {/* Generic Placeholder Content */}
        <p>
            This is a generic privacy policy template for the starter kit. You should replace this with your actual legal text.
        </p>
        
        <h2 className="text-2xl font-semibold pt-4 border-b pb-2">1. INFORMATION WE COLLECT</h2>
        <p>
            We collect personal data that you voluntarily provide to us when you register for an account, such as your name and email address.
        </p>

        <h2 className="text-2xl font-semibold pt-4 border-b pb-2">2. CONTACT US</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us at <a href={`mailto:${dpoEmail}`} className="text-primary hover:underline">{dpoEmail}</a>.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
